import {handlePageLoader, handleToast, Logout} from '../../utils/handler';
import store from "../store";
import * as types from './types';


export function CatchReturnError(error: any) {
  let message: {result: string} | string = "Something went wrong"
  if (error.response) {
    message = error.response.data
    if (error.response.status === 401) {
      Logout()
      return true
    }
  } else if (error.request) {
    message = error.request
  } else {
    message = error.message
  }
  let statusCode = error?.response?.status
  if (statusCode === 307) {
    store.dispatch({type: types.LOCATION_NOT_SUPPORT, payload: true})
    return true
  }
  if (statusCode === 451) {
    store.dispatch({type: types.ROBOT_PAGE, payload: true})
    return true
  }


  handleToast({message})
  handlePageLoader(false)
  return message
}
